// TODO incomplete
const riskAssessment = {
    A: {
        "name": "Class A",
        "description": "Number of A-class measurement points within the block (A-most reliable, E-least reliable)"
    },
    B: {
        "name": "Class B",
        "description": "Number of A-class measurement points within the block (A-most reliable, E-least reliable)"
    },
    C: {
        "name": "Class C",
        "description": "Number of A-class measurement points within the block (A-most reliable, E-least reliable)"
    },
    D: {
        "name": "Class D",
        "description": "Number of A-class measurement points within the block (A-most reliable, E-least reliable)"
    },
    count: {
        "name": "Count",
    },
    haz_0_10: {
        "name": "Displacement rates 0 – 10",
        "description": "Number of measurement points with absolute annual displacement rate between 0 – 10 mm / year within the block"
    },
    haz_10_20: {
        "name": "Displacement rates 10 - 20",
        "description": "Number of measurement points with absolute annual displacement rate between 10 - 20 mm / year within the block"
    },
    haz_20_30: {
        "name": "Displacement rates 20 - 30",
        "description": "Number of measurement points with absolute annual displacement rate between 20 - 30 mm / year within the block"
    },
    haz_30_40: {
        "name": "Displacement rates 30 - 40",
        "description": "Number of measurement points with absolute annual displacement rate between 30 - 40 mm / year within the block"
    },
    haz_40_50: {
        "name": "Displacement rates 40 - 50",
        "description": "Number of measurement points with absolute annual displacement rate between 40 - 50 mm / year within the block"
    },
    haz_50_: {
        "name": "Displacement rates > 50",
        "description": "Number of measurement points with absolute annual displacement rate above 50 mm / year within the block"
    },
    km: {
        "name": "Stationing from Kale",
        "unit": "km"
    },
    ls_freq: {
        "name": "Number of detected landslides"
    },
    max: {
        "name": "Zonal maximum",
        "unit": "mm/yr"
    },
    median: {
        "name": "Zonal 50-percentile (median)",
        "unit": "mm/yr"
    },
    mean: {
        "name": "Zonal mean",
        "unit": "mm/yr"
    },
    min: {
        "name": "Zonal minimum",
        "unit": "mm/yr"
    },
    p25: {
        "name": "Zonal 25-percentile",
        "unit": "mm/yr",
        "description": "25-percentile of aggregated annual displacement rate from detected PS points within topographic unit"
    },
    p75: {
        "name": "Zonal 75-percentile",
        "unit": "mm/yr",
        "description": "75-percentile of aggregated annual displacement rate from detected PS points within topographic unit"
    },
    p75_weight: {
        "name": "Weighted zonal 75-percentile (uphill + downhill)",
        "unit": "mm/yr",
        "description": "75-percentile of aggregated annual displacement rate from detected PS points within respective uphill and downhill topographic units"
    },
    p75_dts: {
        "name": "Zonal 75-percentile (dts)",
        "unit": "mm/yr"
    },
    susc_mean: {
        "name": "Mean"
    },
    susc_p83: {
        "name": "75-percentile"
    },
    susc_m_rng: {
        "name": "Range"
    },
    susc_m_std: {
        "name": "Standard deviation"
    },
    type: {
        "name": "Topographic zone type"
    },
    zone_id: {
        "name": "Road segment ID"
    }
};

const interferometry = {
    aspect: {
        "name": "Slope aspect (from DEM)",
        "unit": "",
        "description": "Slope aspect calculated from 30m Copernicus DEM"
    },
    az_ang: {
        "name": "Radar azimuth angle (LOS)",
        "unit": "°",
        "description": "Global azimuth angle of the LOS"
    },
    cl_dyn: {
        "name": "Displacement trend dynamics",
        "unit": "",
        "description": "Dynamics of displacement trend over the whole period of observation"
    },
    cl_prg: {
        "name": "Displacement trend",
        "unit": "",
        "description": "Displacement trend over the whole period of observation "
    },
    coh: {
        "name": "Coherence"
    },
    coh_mod: {
        "name": "Model coherence",
        "description": "Model coherence - quality/precision measure ranging from 0 to 1 (0-worst, 1-best quality). Its value is not related to linear displacement trend, but to piecewise displacement trend"
    },
    h: {
        "name": "Height of the point taken from the reference DEM",
        "unit": "m",
        "description": "height of the point taken from the reference DEM"
    },
    h_ref: {
        "name": "Estimated relative height of the point, w.r.t. h",
        "unit": "m",
        "description": "estimated relative height of the point, w.r.t. h"
    },
    id: {
        "name": "PS point ID"
    },
    inc_ang: {
        "name": "Radar incidence angle (LOS)",
        "unit": "°",
        "description": "Local incidence angle of the LOS. Related to positin within satellite scene from specific orbital track."
    },
    method: {
        "name": "Interferometric method",
        "unit": "",
        "description": "Origin of the PS/DS"
    },
    orbit: {
        "name": "Orbital track type",
        "description": "Ascending or descending type of orbital geometry"
    },
    rel_cm: {
        "name": "PSI reliability class",
        "description": "Reliability class based on combination of coherence and sensitivy. A - best reliability, D-worse reliability"
    },
    rel_track: {
        "name": "Orbital track",
        "description": "Relative no. of the orbital track"
    },
    s0: {
        "name": "Standard deviation of one measurement",
        "unit": "mm",
        "description": "Standard deviation of one measurement"
    },
    sens: {
        "name": "Radar sensitivity",
        "unit": "",
        "description": "Sensitivity of radar geometry (LOS) to down-the-slope (DTS) direction"
    },
    slope: {
        "name": "Slope gradient (from DEM)",
        "unit": "",
        "description": "Slope grading calculated from 30m Copernicus DEM"
    },
    vacc_mod: {
        "name": "Model displacement rate accuracy",
        "unit": "mm/yr",
        "description": ""
    },
    vel_acc: {
        "name": "Standard deviation of annual displacement rate",
        "unit": "mm/yr",
        "description": "Standard deviation of annual displacement rate"
    },
    vel_avg: {
        "name": "Annual displacement rate",
        "unit": "mm/yr"
    },
    vel_cum: {
        "name": "Cumulative displacement ",
        "unit": "mm",
        "description": "Cumulative displacement between the first and last acquisition"
    },
    val_rank: {
        "name": "Validation score",
        "description": "Number of successfully passed statistical tests in frame of internal validation using measurements from individual"
    },
    vel_sd: {
        "name": "Standard deviation of annual displacement rate",
        "unit": "mm/yr",
        "description": "Standard deviation of annual displacement rate"
    },
    xxx: {
        "name": "",
        "unit": "",
        "description": ""
    },
};

export default {
    interferometry,
    riskAssessment: {
        zones: riskAssessment,
        roads: riskAssessment
    }
}